import { Instance } from 'mobx-state-tree';
import { RouteUnpublishingFailedDtoModelBase } from './RouteUnpublishingFailedDtoModel.base';

/* The TypeScript type of an instance of RouteUnpublishingFailedDtoModel */
export interface RouteUnpublishingFailedDtoModelType extends Instance<typeof RouteUnpublishingFailedDtoModel.Type> {}

/* A graphql query fragment builders for RouteUnpublishingFailedDtoModel */
export { selectFromRouteUnpublishingFailedDto, routeUnpublishingFailedDtoModelPrimitives, RouteUnpublishingFailedDtoModelSelector } from './RouteUnpublishingFailedDtoModel.base';

/**
 * RouteUnpublishingFailedDtoModel
 *
 * Route unpublishing failed event
 */
export const RouteUnpublishingFailedDtoModel = RouteUnpublishingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
